import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { BroadCastEvents } from '../../../common/broad-cast-events.enum';
import { FittingReport2GetFormDataRequest, FittingReport2SaveFormDataRequest } from '../../../models/fitting-report-2';
import { FittingReport2DataService } from '../../../services/fitting-report-2-data.service';
import { SecureBaseComponentContext } from '../../tcm-common/services/secure-base-component-context.service';
import { TcmSecureBaseComponent } from '../../tcm-common/security/tcm-secure-base-component';
import { ActionButtonDirective } from '../../tcm-common/directives/action-button.directive';
import { RoleAccessSettings } from '../../../models/roles';

@Component({
    selector: 'fitting-report-2-editor',
    templateUrl: './fitting-report-2-editor.component.html',
    styleUrls: ['./fitting-report-2-editor.component.scss'],
    standalone: false
})
export class FittingReportEditorComponent extends TcmSecureBaseComponent<FittingReport2GetFormDataRequest, string> {
  public content: SafeHtml;

  @ViewChild(ActionButtonDirective, { static: true }) private saveButton: ActionButtonDirective;

  @ViewChild('reportForm', { static: true }) public reportForm: ElementRef;

  constructor(protected override componentContext: SecureBaseComponentContext,
    protected override route: ActivatedRoute,
    private fittingReport2DataService: FittingReport2DataService,
    private _sanitizer: DomSanitizer) {
    super(componentContext, route);

    this.actionName = 'FittingReport2/GetFormContent';
  }

  async save() {
    const inputs = this.reportForm.nativeElement.getElementsByTagName('input') as HTMLInputElement[];
    let values = {};

    for (const input of inputs) {
      switch (input.type) {
        case "text": {
          values[`@${input.name}@`] = input.value;
          break;
        }
        case "checkbox": {
          values[`@${input.name}@`] = input.checked ? 'checked' : '';
          break;
        }
      }
    }

    const request: FittingReport2SaveFormDataRequest = {
      jsonString: JSON.stringify(values),
      patientId: this.requestModel.patientId,
      salesOrderId: this.requestModel.salesOrderId
    };

    await this.fittingReport2DataService.saveFormData(request, this.componentCancellationTokenSource.promise());   

    this.componentContext.broadcastService.next({ name: BroadCastEvents.PatientDocumentChanged });
    this.goBack();
  }

  back(){
    this.goBack();
  }

  protected createRequestModel(): any {
    return {};
  }

  protected override onPermissionChanged(){
    this.saveButton.toggleDisplay(this.canEdit);
  }

  protected override async onViewModelChanged() {
    super.onViewModelChanged();
    this.saveButton.toggleDisplay(this.canEdit && this.requestModel.isPatientActive);
    this.content = this._sanitizer.bypassSecurityTrustHtml(await this.viewModel);
  }
}
